import { useQuery } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiSuccessfulResponse,
  V3ApiFailedResponse,
} from 'javascripts/services/v3ApiClient';
import { PublicProfileObject } from 'data/v3/data-contracts';

import { PUBLIC_PROFILES_QUERY_KEY } from '../constants';

export type GetPublicProfilesResponse = V3ApiSuccessfulResponse<
  PublicProfileObject[]
>;

export const useGetPublicProfiles = () => {
  return useQuery<GetPublicProfilesResponse, V3ApiFailedResponse>({
    queryFn: () => {
      return request({
        url: `/companies/public_profiles`,
      });
    },
    queryKey: [PUBLIC_PROFILES_QUERY_KEY],
  });
};
